import { createFileRoute } from '@tanstack/react-router'


import {isCurrentPage, validateSearchWithDefaults} from "@/lib/utils";
import InviteHistory from "@/modules/invite-feedback/history";
import {inviteHistoryQueryOptions} from "@/modules/invite-feedback/history/hooks";
import {
  defaultFetchParamsInviteHistory, InviteHistorySearch, mergedInviteHistorySchema,
} from "@/types/route-search-schemas";
import {DataLoader} from "@/types/router-context";
import {INVITE_HISTORY_PATH, INVITE_HISTORY_URL} from "@/utils/urls";

export const Route = createFileRoute(INVITE_HISTORY_PATH)({
  component: InviteHistoryPage,
  validateSearch: (search: Record<string, unknown>): InviteHistorySearch => validateSearchWithDefaults(mergedInviteHistorySchema, search),
  loader: ({ context: { queryClient } }: DataLoader) => {
    if (isCurrentPage(INVITE_HISTORY_URL)) {
      return
    }
    queryClient.prefetchQuery(inviteHistoryQueryOptions(defaultFetchParamsInviteHistory))
  },
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Invite feedback', path: '#' },
        { label: 'Invite history', path: INVITE_HISTORY_URL },
      ],
      children: null
    }
  },
})

function InviteHistoryPage() {
  return(
    <div className={'flex flex-col items-center justify-center'}>
      <InviteHistory />
    </div>
  )
}

